module.exports = __webpack_public_path__ + "img/accessibility.e2d723cb.jpg";